import React from 'react'
import { Link } from 'react-router-dom'

const ResetPasswordPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-center text-3xl font-bold tracking-tight text-gray-900">
          Reset your password
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Enter your new password below
        </p>
      </div>

      <form className="space-y-6">
        <div>
          <label htmlFor="password" className="block text-sm font-medium text-gray-700">
            New password
          </label>
          <div className="mt-1">
            <input
              type="password"
              className="form-input"
              placeholder="Enter new password"
            />
          </div>
        </div>

        <div>
          <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
            Confirm password
          </label>
          <div className="mt-1">
            <input
              type="password"
              className="form-input"
              placeholder="Confirm new password"
            />
          </div>
        </div>

        <div>
          <button type="submit" className="btn btn-primary w-full btn-lg">
            Reset password
          </button>
        </div>
      </form>

      <div className="text-center">
        <Link
          to="/auth/login"
          className="font-medium text-primary-600 hover:text-primary-500 transition-colors"
        >
          Back to login
        </Link>
      </div>
    </div>
  )
}

export default ResetPasswordPage